import { LOCAL_STORAGE_KEYS } from "@/constant/keys";
import { miniAppAPI } from ".";

export async function issueMiniAppSignedToken(initData: string) {
  const response = await miniAppAPI.request<{
    user: Moim.User.IOriginalUserDatum;
    accessToken: string;
    refreshToken: string;
  }>({
    method: "POST",
    url: "/auth/ton",
    data: { initData },
  });
  const { accessToken, refreshToken } = response;
  localStorage.setItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN, refreshToken);
  localStorage.setItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN, accessToken);

  return response;
}
